import { FunctionComponent, ReactNode } from 'react';
import { WCCFooter } from '../WCCFooter/WCCFooter';
import { WCCHeader } from '../WCCHeader/WCCHeader';
import { CookieBanner } from '@molecules/CookieBanner/CookieBanner';

export interface DashboardLayoutProps {
  children?: ReactNode;
  headerAction?: ReactNode;
}

export const DashboardLayout: FunctionComponent<DashboardLayoutProps> = ({
  children,
  headerAction,
}) => {
  return (
    <main className="bg-background-default grid min-h-screen grid-rows-[min-content_min-content_1fr_min-content] overflow-hidden overflow-x-hidden">
      <CookieBanner />
      <WCCHeader headerAction={headerAction} />
      <section id="main-content">{children}</section>
      <WCCFooter />
    </main>
  );
};

export default DashboardLayout;
